 
<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-b" data-toggle="modal" data-target="#exampleModal">Add</button>
            <div class="personal-details">
                <h4 class="personal-details-title">Plans List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Group</th>
                      <th scope="col">Heading</th>
                      <th scope="col">SubHeading</th>
                      <th scope="col">Publicly Visible</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of planData; let i=index">
                      <th scope="col" >{{x.name}}</th>
                      <th scope="col" >{{x.group}}</th>
                      <th scope="col" >{{x.planHeading}}</th>
                      <th scope="col" >{{x.planSubHeading}}</th>
                      <th scope="col" >{{x.isPubliclyVisible}}</th>
                      <th scope="col" >{{x.planAmount}}</th>
                      <th scope="col" > 
                        
                        <i class="bi bi-trash3" data-toggle="modal" data-target="#deleteModal" (click)="selectServiceId(x.id)"></i>
                        <i class="bi bi-pencil-square" (click)="getMarketingDataById(data.id)" data-toggle="modal" data-target="#updateModal"></i>
                        <i class="bi bi-eye-fill" data-toggle="modal" data-target="#viewModal" (click)="getPlanById(x.planInfoId)"></i>
                      </th>
                    </tr>
                  </tbody>
                </table>
            </div> -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Plans List</p>
                  </div>
                  <div class="add-block">
                      <div class="search">
                          <form autocomplete="off" >
                              <input type="text" placeholder="search ">
                          </form>
                          <i class="bi bi-search" ></i>
                      </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 15%;">Name</th>
                        <th style="width: 20%;">Group</th>
                        <th style="width: 15%;">Heading</th>
                        <th style="width: 15%;">SubHeading</th>
                        <th style="width: 15%;">Publicly Visible</th>
                        <th style="width: 10%;">Amount</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let plan of planData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                      }  ;let i = index">
      
                      <p style="width: 15%;">{{plan.name}}</p>
                      <p style="width: 20%;">{{plan.group}}</p>
                      <p style="width: 15%;">{{plan.planHeading}}</p>
                      <p style="width: 15%;">{{plan.planSubHeading}}</p>
                      <p style="width: 15%;">{{plan.isPubliclyVisible}}</p>
                      <p style="width: 10%;">{{plan.planAmount}}</p>
                      <p class="action-buttons" style="width: 10%;">
                          <i *ngIf="actionControls.isModify" (click)="getPlanById(plan.planInfoId)" data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
                          <i *ngIf="actionControls.isView" data-toggle="modal" data-target="#viewModal" (click)="getPlanById(plan.planInfoId)" class="bi bi-eye-fill"></i>
                          <i *ngIf="actionControls.isDelete" (click)="del(plan.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                      </p>
                  </div>
              </div>
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && planData.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Plan
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>Select Service <span class="required-field">*</span></label>
                <select formControlName="serviceId" class="form-control">
                  <option value="{{service.serviceId}}" *ngFor="let service of serviceData">
                    {{service.name}}
                  </option>
                </select>
                <span class="err" *ngIf="form.get('serviceId').invalid && formSubmit">service required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Name <span class="required-field">*</span></label>
                  <input formControlName="name" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('name').invalid && formSubmit">name required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Group</label>
                  <input formControlName="group" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('group').invalid && formSubmit">group required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Heading <span class="required-field">*</span></label>
                  <input formControlName="serviceHeading" type="text" class="form-control">
                  <span class="err" *ngIf="form.get('serviceHeading').invalid && formSubmit">Plan heading required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Sub Heading <span class="required-field">*</span></label>
                <input formControlName="serviceSubHeading" type="text" class="form-control">
                <span class="err" *ngIf="form.get('serviceSubHeading').invalid && formSubmit">Plan sub heading required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>Plan Amount <span class="required-field">*</span></label>
                    <input formControlName="serviceAmount" type="number" class="form-control">
                    <!-- <span class="err" *ngIf="form.get('serviceAmount').invalid && formSubmit">Plan required</span> -->
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>Tax Included </label>
                    <select name="" id="" formControlName="taxIncluded" class="form-control">
                      <option value="true">Included</option>
                      <option value="false" selected>Not Included</option>
                    </select>
                    <!-- <span class="err" *ngIf="form.get('serviceAmount').invalid && formSubmit">Plan required</span> -->
                  </div>
                </div>
               
              </div>
      
              <!-- <div class="col-md-6 col-lg-6">
                <label>OneTime Charge <span class="required-field">*</span></label>
                <input formControlName="oneTimeCharge" type="number" class="form-control">
                <span class="err" *ngIf="form.get('oneTimeCharge').invalid && formSubmit">one time charge required</span>

              </div>
              <div class="col-md-6 col-lg-6">
                <label>Monthly Charge <span class="required-field">*</span></label>
                <input formControlName="monthlyCharge" type="number" class="form-control">
                <span class="err" *ngIf="form.get('monthlyCharge').invalid && formSubmit">monthly charge required</span>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Usage Charge <span class="required-field">*</span></label>
                <input formControlName="usageCharge" type="number" class="form-control">
                <span class="err" *ngIf="form.get('monthlyCharge').invalid && formSubmit">usage charge required</span>
              </div> -->

              <div class="col-md-6 col-lg-6">
                <div class="row">
                  
                  <div class="col-md-6 col-lg-6">
                    <label>Tax Percentage </label>
                    <input formControlName="taxPercentage" type="number" class="form-control">
                    <!-- <span class="err" *ngIf="form.get('serviceAmount').invalid && formSubmit">Plan required</span> -->
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Plan InfoType</label>
                      <select name="" id="" formControlName="planInfoType" class="form-control">
                        <option value="POSTPAID">POSTPAID</option>
                        <option value="PREPAID">PREPAID</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="row">
                  

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Add On Plan</label>
                      <select name="" id="" formControlName="addonPlan" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Publicly Visible</label>
                      <select name="" id="" formControlName="isPubliclyVisible" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              
             
            </div>
            <div class="row">
              <h5 class="lab-h">Plan Details</h5>

                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of prod;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="prod[i].key" [ngModelOptions]="{standalone: true}">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter value" [(ngModel)]="prod[i].value[j].value">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addi(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removeValue(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeProd(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeProd(i)">remove</button>
                      <button (click)="addP()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>

                <h5 class="lab-h">Integration Details</h5>

                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of integrationKeyValue;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="integrationKeyValue[i].key" [ngModelOptions]="{standalone: true}">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter value" [(ngModel)]="integrationKeyValue[i].value[j].value">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addintegration(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removevintegration(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeintegration(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeintegration(i)">remove</button>
                      <button (click)="addvintegration()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>
            </div>

            <h5 class="lab-h">Charge Details</h5>
            <div class="col-md-12 col-lg-12" class="chargeDetail">
              <div formArrayName="chargeDetail">
                <div class="chargeDetail-fields" *ngFor="let change of form.controls.chargeDetail['controls'];let i = index;let last = last" [formGroupName]="i">
                  <input type="text" formControlName="chargeHeading" placeholder="enter charge heading">
                  <input type="text" formControlName="chargeName" placeholder="enter charge name">
                  <input type="text" formControlName="chargeAmount" placeholder="enter amount">
                  <select name="" id="" formControlName="chargeType">
                    <option value="select type" selected disabled>select type</option>
                    <option value="NRC">NRC</option>
                    <option value="RC">RC</option>
                    <option value="UC">UC</option>
                  </select>
                  <i class="bi bi-plus-circle" *ngIf="last" (click)="addChargeDetail()"></i>
                  <i class="bi bi-dash-circle" (click)="removeChargeDetail(i)" *ngIf="!last"></i>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">Cancel</button>
              <button type="button" (click)="addPlan()" class="btn btn-primary">Add Plan</button>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Plan Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of viewPlan">
            <div class="form-group">
              <div class="row">
                  <div class="col-md-6 col-lg-6">
                      <label>Plan Name :</label>
                      <p>{{viewData.name}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                      <label>Plan Group :</label>
                      <p>{{viewData.group}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>Plan Heading :</label>
                    <p>{{viewData.planHeading}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>Plan Sub Heading :</label>
                    <p>{{viewData.planSubHeading}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>Total Amount :</label>
                    <p>{{viewData.planAmount}}</p>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                    <h5 class="label-h">Plan Details</h5>
                    <div class="col-md-6 col-lg-6" *ngFor="let item of viewData.planKeyValue;">
                      <div class="row">
                        <div class="col-md-6 col-lg-6">
                          <p style="width: 100%;font-weight: 700;">{{item.key}} <span style="float: right">:</span> </p>
                        </div>
                        <div class="col-md-6 col-lg-6">
                          <p *ngFor="let value of item.value;">{{value}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <h5 class="label-h">Charge Details</h5>
                    <div class="status-table">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Charge Heading</th>
                            <th scope="col">Charge Name</th>
                            <th scope="col">Charge Amount</th>
                            <th scope="col">Charge Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let charge of viewData.chargeDetail;">
                            <th>{{charge.chargeHeading}}</th>
                            <th>{{charge.chargeName}}</th>
                            <th>{{charge.chargeAmount}}</th>
                            <th>{{charge.chargeType}}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
            <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
            </span>
          </h5>
      </div>
      <div class="modal-body">
          <p>are you sure? want to delete??</p>   
      <div class="modal-footer">
          <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteService()" class="btn btn-primary">Delete</button>
      </div>
      </div>
  </div>
  </div>
</div>




<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Plan
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>Select Service <span class="required-field">*</span></label>
                <select [(ngModel)]="singlePlanData.serviceId" class="form-control">
                  <option value="{{service.serviceId}}" *ngFor="let service of serviceData">
                    {{service.name}}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Name <span class="required-field">*</span></label>
                  <input [(ngModel)]="singlePlanData.name" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                  <label>Plan Group</label>
                  <input [(ngModel)]="singlePlanData.group" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Heading <span class="required-field">*</span></label>
                  <input [(ngModel)]="singlePlanData.planHeading" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <label>Plan Sub Heading <span class="required-field">*</span></label>
                <input [(ngModel)]="singlePlanData.planSubHeading" type="text" class="form-control">
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>Plan Amount <span class="required-field">*</span></label>
                    <input [(ngModel)]="singlePlanData.planAmount" type="number" class="form-control">
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>Tax Included </label>
                    <select name="" id="" [(ngModel)]="singlePlanData.taxIncluded" class="form-control">
                      <option value="true">Included</option>
                      <option value="false" selected>Not Included</option>
                    </select>
                  </div>
                </div>
              </div>
             
              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>Tax Percentage </label>
                    <input [(ngModel)]="singlePlanData.taxPercentage" type="number" class="form-control">
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Plan InfoType</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.planInfoType" class="form-control">
                        <option value="POSTPAID">POSTPAID</option>
                        <option value="PREPAID">PREPAID</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Add On Plan</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.addonPlan" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Publicly Visible</label>
                      <select name="" id="" [(ngModel)]="singlePlanData.isPubliclyVisible" class="form-control">
                        <option value="true">True</option>
                        <option value="false" selected>False</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              
             
            </div>
            <div class="row">
              <h5 class="lab-h">Plan Details</h5>
                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of singlePlanData.planKeyValue;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="singlePlanData.planKeyValue[i].key">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" placeholder="enter value" [(ngModel)]="singlePlanData.planKeyValue[i].value[j]">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addi(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removeValue(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeProd(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeProd(i)">remove</button>
                      <button (click)="addP()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>

                <h5 class="lab-h">Integration Details</h5>

                <div class="col-md-12 col-lg-12">
                  <div *ngFor="let item of singlePlanData.integrationKeyValue;let i = index;let itemLast = last;">
                    <div class="productList" >
                      <div class="row">
                        <div class="col-md-12 col-lg-12">
                          <!-- <label>key</label> -->
                          <input class="form-control" placeholder="enter name" [(ngModel)]="singlePlanData.integrationKeyValue[i].key">
                        </div>
                      </div>
                      <div class="infoObj" *ngFor="let value of item.value; let j = index;let last = last">
                        <input style="width:100%;margin-right:4px" type="text" class="form-control" placeholder="enter value" [(ngModel)]="singlePlanData.integrationKeyValue[i].value[j]">
                        <i class="bi bi-plus-circle" *ngIf="last" (click)="addintegration(i)"></i>
                        <i class="bi bi-dash-circle" (click)="removevintegration(i,j)" *ngIf="!last"></i>
                      </div>
                    </div>
                    <div class="add-remove-button" *ngIf="!itemLast">
                      <button (click)="removeintegration(i)">remove</button>
                    </div>
                    <div class="add-remove-button" *ngIf="itemLast">
                      <button *ngIf="i!=0" (click)="removeintegration(i)">remove</button>
                      <button (click)="addvintegration()" style="margin-left: 10px;">add</button>
                    </div>
                  </div>
                </div>
            </div>

            <h5 class="lab-h">Charge Details</h5>
            <div class="col-md-12 col-lg-12" class="chargeDetail">
              <div>
                <div class="chargeDetail-fields" *ngFor="let change of singlePlanData.chargeDetail;let i = index;let last = last">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeHeading" placeholder="enter charge heading">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeName" placeholder="enter charge name">
                  <input type="text" [(ngModel)]="singlePlanData.chargeDetail[i].chargeAmount" placeholder="enter amount">
                  <select name="" id="" [(ngModel)]="singlePlanData.chargeDetail[i].chargeType">
                    <option value="select type" selected disabled>select type</option>
                    <option value="NRC">NRC</option>
                    <option value="RC">RC</option>
                    <option value="UC">UC</option>
                  </select>
                  <i class="bi bi-plus-circle" *ngIf="last" (click)="addChargeDetail()"></i>
                  <i class="bi bi-dash-circle" (click)="removeChargeDetail(i)" *ngIf="!last"></i>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" id="closeModalButton3" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">Cancel</button>
              <button type="button" (click)="updatePlan()" class="btn btn-primary">Add Plan</button>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</div>